import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";

export default function CartLink({ className }) {
    const [count, setCount] = useState(0);
    const role = localStorage.getItem("role");

    useEffect(() => {
        if (role !== "customer") return;
        fetch(`${API_BASE_URL}/api/customer/cart`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        })
            .then(res => res.json())
            .then(data => setCount(Array.isArray(data) ? data.length : 0))
            .catch(() => setCount(0));
    }, [role]);

    if (role !== "customer") return null;

    // Leading slash. Without it this was a relative path, so from /devices the
    // cart link went to /devices/customer/cart and 404'd -- which is most of
    // the app, since Browse is where you add things to the cart in the first
    // place.
    return (
        <Link to="/customer/cart" className={className}>
            Cart
            {count > 0 && <span className="notification-dot">{count}</span>}
        </Link>
    );
}
